import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full border-t-2 px-8 py-3 lg:flex justify-between items-center" }
const _hoisted_2 = { class: "mb-2 lg:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://app.pipedrive.com/auth/login",
    class: "mr-6 hover:text-gray-900"
  }, "Pipedrive"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.zendesk.fr/login/",
    class: "mr-6 hover:text-gray-900"
  }, "Zendesk")
], -1)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const currentYear = ref<number>(new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "© Copyright Club Employés " + _toDisplayString(currentYear.value), 1),
    _hoisted_3
  ]))
}
}

})